import { Ridgeline } from "@/components/common/Ridgeline";

// Tiny tracked-caps eyebrow label sitting above every section.
export const Eyebrow = ({ children, className = "", color = "#C89A4E", testId }) => (
  <span
    className={`eyebrow inline-flex items-center gap-3 ${className}`}
    style={{ color }}
    data-testid={testId}
  >
    <span
      aria-hidden="true"
      style={{ width: 28, height: 1, backgroundColor: color, opacity: 0.7 }}
    />
    {children}
  </span>
);


/* Generic section wrapper — pine/stone/etc. background + centred inner width */
export const Section = ({ bg, py = "py-24 md:py-32", children, className = "", testId }) => (
  <section className={`${py} ${className}`} style={bg ? { backgroundColor: bg } : undefined} data-testid={testId}>
    <div className="mx-auto max-w-[1440px] px-6 md:px-10">{children}</div>
  </section>
);

// A ridgeline section divider.
export const SectionDivider = ({ stroke = "#C89A4E", variant = "a", className = "" }) => (
  <div className={`w-full ${className}`} aria-hidden="true">
    <Ridgeline stroke={stroke} variant={variant} animate height={110} />
  </div>
);
